import { supabase } from "@/integrations/supabase/client";
import {
  TERMS_DOCUMENT_ID,
  TERMS_VERSION,
} from "@/lib/terms-metadata";

export type TermsAcceptanceRecord = {
  document_id: string;
  version: string;
  accepted_at: string;
  acceptance_method: "signup" | "modal" | "oauth";
};

export async function recordTermsAcceptance(
  userId: string,
  method: TermsAcceptanceRecord["acceptance_method"],
): Promise<{ error: Error | null }> {
  const now = new Date().toISOString();
  const acceptance: TermsAcceptanceRecord = {
    document_id: TERMS_DOCUMENT_ID,
    version: TERMS_VERSION,
    accepted_at: now,
    acceptance_method: method,
  };

  const { error: profileError } = await supabase
    .from("profiles")
    .update({
      terms_accepted_at: now,
      privacy_accepted_at: now,
    })
    .eq("id", userId);

  if (profileError) {
    return { error: profileError };
  }

  const { error: metadataError } = await supabase.auth.updateUser({
    data: {
      terms_acceptance: acceptance,
    },
  });

  if (metadataError) {
    console.warn("Terms acceptance saved on profile, but metadata update failed:", metadataError);
  }

  return { error: null };
}
